import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { TransactionReceiptFacade } from './+state';
import { TransactionReceiptStateModule } from './+state/transaction-receipt.state.module';
import { TransactionReceiptService } from './services';

@NgModule({
  imports: [CommonModule, TransactionReceiptStateModule],
})
export class DomainTransactionReceiptModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: DomainTransactionReceiptModule,
      providers: [TransactionReceiptService, TransactionReceiptFacade],
    };
  }
}
